module.exports = __webpack_public_path__ + "static/img/title-es.12cea01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/title-es.png
// module id = S5M5
// module chunks = 1